<template>
  <div class="my_calendar bgwhite">
    <vue-cal
      xsmall
      hide-view-selector
      default-view="month"
      :disable-views="['years', 'year', 'week', 'day']"
      :selected-date="selected"
      :locale="locale"
      :clickToNavigate="false"
      :dblClickToNavigate="false"
      :events="events"
      @view-change="viewChange"
      @cell-click="dayClick"
    />
  </div>
</template>

<script>
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
import { formatDate } from '@/utils/index'

export default {
  name: 'MyCalendar',
  components: {
    VueCal
  },
  props: {
    dayEvents: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      selected: '',
      locale: 'zh-cn',
      events: []
    }
  },
  watch: {
    dayEvents: {
      deep: true,
      handler: function (newVal, oldVal) {
        this.getEvents(newVal)
      }
    }
  },
  created () {
    this.getEvents(this.dayEvents)
  },
  methods: {
    getEvents (dayEvents) {
      let events = []
      for (let index = 0; index < this.dayEvents.length; index++) {
        const dayEvent = this.dayEvents[index]
        events.push({
          start: dayEvent,
          end: dayEvent
        })
      }
      this.events = events
    },
    viewChange (res) {
      if (res.view !== 'month') {
        return false
      }

      const startDate = res.startDate
      // const year = startDate.getFullYear()
      // const month = startDate.getMonth() + 1
      let dateStr = formatDate(startDate)
      this.$emit('month-change', dateStr)
    },
    dayClick (date) {
      let dateStr = formatDate(date)
      this.$emit('day-click', dateStr)
    }
  }
}
</script>

<style lang="scss">
.my_calendar {
  font-size: 30px;
  width: 100%;
  height: 750px;
  .vuecal__title-bar {
    background: #fff;
  }
  .vuecal__cell.today,
  .vuecal__cell.current {
    background-color: rgba(240, 240, 255, .7);
  }
  .vuecal__cell.selected {
    background-color: rgba(235, 255, 245, .7);
  }
  .vuecal__cell-events-count {
    width: 18px;
    height: 2px;
    color: transparent;
    background-color: rgba(255,179,0,.8);
  }
  // .vuecal__cell--has-events {background-color: #fffacd;}
  // .vuecal__cell-events-count {display: none;}
  .vuecal {
    box-shadow: none;
  }
  .vuecal__title {
    background-color: #fff;
  }
}
</style>
